import { post } from '../../../../redux/api';
import type { GenerateCSVAuditLogsResponse } from '../../../../../shared/types/routes/auditLogs';
import useToastedMutation from '../../../../ReactQuery/useToastedMutation';

export type AuditLogExportParams = {
  topics?: string[];
  actions?: string[];
  topicActions?: string[];
  startDate?: string;
  endDate?: string;
  actingUserIds?: string[];
};

function createAuditLogExport(params: AuditLogExportParams) {
  return post<AuditLogExportParams, GenerateCSVAuditLogsResponse>('/api/audit_logs/export', params);
}

/**
 * Creates a mutation that exports audit logs to CSV
 */
export default function useCreateAuditLogExport() {
  return useToastedMutation({
    mutationFn: (params: AuditLogExportParams) => createAuditLogExport(params),
    successToastMessage: 'Your export is being generated and will be emailed to you',
    errorToastMessage: 'Failed to create audit log export',
  });
}
